<template>
  <InactivityWarningModal v-if="showWarning" :seconds-left="secondsLeft" @stay="stayLoggedIn" />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

import { useActivityTracker } from '@/hooks/use-activity-tracker';
import { useInactivityMonitor } from '@/hooks/use-inactivity-monitor';
import { useAuthStore } from '@/stores/auth.store';
import { onSession } from '@/utils/session-channel';
import InactivityWarningModal from '@/components/session/InactivityWarningModal.vue';

// Owns the client-side session policy: tracks activity, polls for inactivity,
// shows the warning modal, and reacts to cross-tab signout / token-updated.
useActivityTracker();
const { showWarning, secondsLeft, stayLoggedIn } = useInactivityMonitor();

const { signout, reloadFromStorage } = useAuthStore();

let removeChannelListener: (() => void) | undefined;

onMounted(() => {
  removeChannelListener = onSession((message) => {
    if (message.type === 'signout') {
      signout(false); // received from another tab → sign out without re-broadcasting
    } else if (message.type === 'token-updated') {
      reloadFromStorage(); // a sibling tab refreshed → re-sync our in-memory user/token
    }
  });
});

onUnmounted(() => {
  removeChannelListener?.();
});
</script>
